import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import FilterCategoryItem from "../categories/filterCategoryItem";
import Reporting from "../campaigns/campaign_reporting";
import CampaignGallery from "../campaigns/CampaignGallery";
import { useSelector } from "react-redux";

const collectionItemsTabs = [
  { id: 1, text: "Campaign Overview", icon: (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  )},
  { id: 2, text: "Updates", icon: (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
    </svg>
  )},
  { id: 3, text: "Gallery", icon: (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  )},
];

const Collection_items = ({
  description,
  feasibility,
  impact,
  campaignDes,
  isSuperCampaign,
  campaignId,
  campaign,
  organization,
}) => {
  const itemsTabIndex = useSelector((state) => state.counter.itemsTabIndex);
  const [itemsTabs, setItemsTabs] = useState(1);

  useEffect(() => {
    // Map old 4-tab index to new 3-tab index
    if (itemsTabIndex <= 1) setItemsTabs(1);
    else if (itemsTabIndex === 4) setItemsTabs(2);
    else setItemsTabs(itemsTabIndex <= 3 ? itemsTabIndex : 1);
  }, [isSuperCampaign, itemsTabIndex]);

  return (
    <section className="relative py-8">
      <div className="container">
        <Tabs selectedIndex={itemsTabs - 1} className="tabs">
          {/* Mobile dropdown */}
          <div className="md:hidden mb-6 px-4">
            <select
              value={itemsTabs}
              onChange={(e) => setItemsTabs(Number(e.target.value))}
              className="w-full appearance-none bg-white dark:bg-[#131740] border border-gray-200 dark:border-[#1f2937] rounded-xl py-3 px-4 text-gray-700 dark:text-white focus:ring-accent focus:border-accent transition-all cursor-pointer font-display font-medium"
            >
              {collectionItemsTabs.map(({ id, text }) => (
                <option key={id} value={id}>{text}</option>
              ))}
            </select>
          </div>

          {/* Desktop tab bar */}
          <TabList className="hidden md:flex nav nav-tabs scrollbar-custom mb-0 items-center justify-start overflow-x-auto overflow-y-hidden border-b border-gray-200 dark:border-[#1f2937] hide-scrollbar px-2">
            {collectionItemsTabs.map(({ id, text, icon }) => {
              const active = itemsTabs === id;
              return (
                <Tab
                  key={id}
                  className="nav-item focus:outline-none"
                  onClick={() => setItemsTabs(id)}
                >
                  <button
                    className={`
                      relative flex items-center gap-2 whitespace-nowrap py-4 px-5 text-sm font-semibold transition-all focus:outline-none
                      ${active
                        ? "text-accent border-b-2 border-accent -mb-px"
                        : "text-jacarta-500 dark:text-jacarta-400 hover:text-accent border-b-2 border-transparent -mb-px"
                      }
                    `}
                  >
                    <span className={active ? "text-accent" : "text-jacarta-400 dark:text-jacarta-500"}>
                      {icon}
                    </span>
                    {text}
                  </button>
                </Tab>
              );
            })}
          </TabList>

          {/* Tab Panels */}
          <div className="pt-6">
            <TabPanel>
              <FilterCategoryItem
                campaign={campaign}
                organization={organization}
                description={description}
              />
            </TabPanel>

            <TabPanel>
              <Reporting campaignId={campaignId} />
            </TabPanel>

            <TabPanel>
              <CampaignGallery
                campaign={campaign}
                organization={organization}
              />
            </TabPanel>
          </div>
        </Tabs>
      </div>
    </section>
  );
};

export default Collection_items;
